var _rect, _path, _path2, _path3, _path4, _path5, _path6, _rect2, _rect3, _rect4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHumaWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 41,
    viewBox: "0 0 174 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.5266,
    y: 17.6313,
    width: 18.1812,
    height: 6.14424,
    fill: "#B246FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9318 1.17157C17.7397 -1.50382 7.716 2.84064 3.54112 11.778C-0.633754 20.7155 2.47137 31.182 10.4277 36.5031L19.9283 16.1644L26.9318 1.17157Z",
    fill: "url(#paint0_linear_623_5464)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1236 3.51593C40.0799 8.837 43.185 19.3035 39.0101 28.2409C34.8352 37.1783 24.8115 41.5228 15.6194 38.8474L25.1201 18.5087L32.1236 3.51593Z",
    fill: "url(#paint1_linear_623_5464)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4301 35.7541C93.1139 35.7541 91.7916 35.3426 89.9738 34.5197C88.5033 33.4834 87.3255 32.2813 86.498 31.0369C85.5011 29.538 85.0027 27.072 85.0027 25.9229V15.4714L92.3491 14.1524V25.7906C92.3491 26.5377 92.613 27.4486 93.1407 28.007C93.6978 28.536 94.7429 28.8767 95.5638 28.8767C96.3554 28.8767 97.4465 28.536 97.9449 28.007C98.4727 27.4486 98.7365 26.6713 98.7365 25.7906V14.5564L106.041 13.2007V25.9229C106.041 27.4727 105.542 29.582 104.545 31.081C103.578 32.5505 102.561 33.6967 100.802 34.5197C99.0432 35.3426 97.717 35.7541 95.4301 35.7541Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M120.21 12.7794C122.527 12.7794 123.583 13.1909 125.4 14.0138C126.871 15.0501 128.049 16.2522 128.876 17.4966C129.873 18.9955 130.372 21.4615 130.372 22.6106L130.372 35.2192L123.025 35.2192L123.025 22.7429C123.025 21.773 122.761 21.0088 122.234 20.4504C121.676 19.9214 120.987 19.6568 120.167 19.6568C119.375 19.6568 118.73 19.9214 118.231 20.4504C117.704 21.0088 117.44 21.773 117.44 22.7429L117.44 35.2192L110.136 35.2192L110.136 22.6106C110.136 21.0608 110.634 18.9515 111.631 17.4525C112.598 15.983 113.615 14.8368 115.374 14.0138C117.133 13.1909 117.924 12.7794 120.21 12.7794Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M133.579 12.7794C135.896 12.7794 136.952 13.1909 138.769 14.0138C140.24 15.0501 141.418 16.2522 142.245 17.4966C143.242 18.9955 143.74 21.4615 143.74 22.6106L143.74 35.2192L136.394 35.2192L136.394 22.7429C136.394 21.773 136.13 21.0088 135.602 20.4504C135.045 19.9214 134.356 19.6568 133.535 19.6568C132.744 19.6568 132.099 19.9214 131.6 20.4504C131.073 21.0088 130.809 21.773 130.809 22.7429L130.809 35.2192L123.505 35.2192L123.505 22.6106C123.505 21.0608 124.003 18.9515 125 17.4525C125.967 15.983 126.984 14.8368 128.743 14.0138C130.502 13.1909 131.293 12.7794 133.579 12.7794Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.717 32.7324C163.775 34.3002 161.303 35.2391 158.612 35.2391C152.365 35.2391 147.301 30.179 147.301 23.9372C147.301 17.6953 152.365 12.6353 158.612 12.6353C161.331 12.6353 163.826 13.5939 165.777 15.1913L172.133 14.0075V35.2388H165.717V32.7324ZM163.877 24.0183C163.877 26.8953 161.543 29.2275 158.664 29.2275C155.784 29.2275 153.45 26.8953 153.45 24.0183C153.45 21.1413 155.784 18.809 158.664 18.809C161.543 18.809 163.877 21.1413 163.877 24.0183Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 53.4534,
    y: 5.03271,
    width: 8.0211,
    height: 30.1869,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 72.1692,
    y: 5.03271,
    width: 8.0211,
    height: 30.1869,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 16.462,
    height: 5.87725,
    transform: "matrix(0.984833 -0.173504 0.173792 0.984782 57.9795 19.2666)",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_623_5464",
    x1: 25.3411,
    y1: 4.57701,
    x2: -23.13,
    y2: -1.34608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_623_5464",
    x1: 30.5328,
    y1: 6.92138,
    x2: 66.1723,
    y2: 40.2751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumaWhite);
export default __webpack_public_path__ + "static/media/huma-white.f0019d62519340f3fcc740995a3dad0c.svg";
export { ForwardRef as ReactComponent };